import { FC, useState } from "react";
import { message, Upload } from "antd";
import {
  UploadRequestError,
  UploadRequestOption,
} from "rc-upload/lib/interface";
import { uploadFileRequest, uploadImageRequest } from "api/upload";
import { getImageUrl } from "utils/urlParser";
import { Button } from "components/Button";
import { UploadFile } from "antd/lib/upload/interface";

interface ButtonUploadProps {
  onChange?: (fileName: string) => void;
  initFileName?: string;
  type?: "image" | "file";
}

function beforeUpload(file: any) {
  const isJpgOrPng =
    file.type === "image/jpeg" ||
    file.type === "image/png" ||
    file.type === "image/gif";
  const isLt5M = file.size / 1024 / 1024 < 5;
  return isJpgOrPng && isLt5M;
}

export const ButtonUpload: FC<ButtonUploadProps> = ({
  initFileName,
  onChange,
  children,
  type = "image",
}) => {
  const [files, setFiles] = useState<UploadFile[]>(
    initFileName
      ? [
          {
            uid: "1",
            name: type === "image" ? initFileName : "file",
            status: "done",
            url: getImageUrl(initFileName),
          },
        ]
      : []
  );

  const handleUploadChange = ({ fileList }: any) => {
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG/GIF file!");
        return;
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error("File must smaller than 5MB!");
        return;
      }
    }
    setFiles(fileList);
  };

  const customRequest = async (option: UploadRequestOption) => {
    const { onSuccess, onError, file } = option;
    if (type === "image") {
      uploadImageRequest(file)
        .then((respones) => {
          onSuccess && onSuccess(respones.data, respones.request);
          const { data } = respones;
          onChange && onChange(data?.filename);
        })
        .catch((err: UploadRequestError) => {
          onError && onError(err);
        });
    } else {
      uploadFileRequest(file)
        .then((respones) => {
          onSuccess && onSuccess(respones.data, respones.request);
          const { data } = respones;
          onChange && onChange(data?.filename);
        })
        .catch((err: UploadRequestError) => {
          onError && onError(err);
        });
    }
  };

  const handleRemove = () => {
    onChange && onChange("");
  };

  return (
    <Upload
      listType="text"
      maxCount={1}
      onChange={handleUploadChange}
      customRequest={customRequest}
      onRemove={handleRemove}
      fileList={files}
      beforeUpload={beforeUpload}
      accept={type === "image" ? "image/*" : ""}
    >
      {children ? (
        children
      ) : (
        <Button size="small" type="primary" color="upload">
          Choose {type === "image" ? "photo" : "file"}
        </Button>
      )}
    </Upload>
  );
};
